module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"row\">\r\n    <div class=\"col-xs-2 prop-sublabel\">Name</div>\r\n    <div class=\"col-xs-10\"><input type=\"text\" name=\"name\" value=\"")
    ; __append(escapeFn( tmpName ))
    ; __append("\" /></div>\r\n</div>\r\n<div class=\"row\">\r\n    <div class=\"col-xs-2 new-font-size\">Type</div>\r\n    <div class=\"col-xs-10 new-font-size\">")
    ; __append(escapeFn( mimeType ))
    ; __append("</div>\r\n</div>")
  }
  return __output;

}